import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import {
  sendCustomerEnvelope,
  declineCustomerSignDocument,
} from "../../services/CommonService";
import Utils from "../../utils";
import SignFillablePopup from "./SignFillablePopup";
import TermsConditions from "../guest-portal/pages/Home/TermsConditions";
import CustomerSummary from "./CustomerSummary";
import ModalComponent from "../../components/ModalComponent";
import "./CustomerPortal.css";

function DocumentsAndForm(props) {
  const [signDocumentList, setSignDocumentList] = useState([]);
  const [signFillRequest, setSignFillRequest] = useState(false);
  const [summaries, setSummaries] = useState(null);
  const [signatureDocumentData, setSignatureDocumentData] = useState(null);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [getStarted, setGetStarted] = useState(false);
  const [showDecline, setShowDecline] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const btnSignDocumentPopup = useRef(null);

  useEffect(() => {
    const offcanvasEl = document.getElementById("signFillableForm");
    if (!offcanvasEl) return;

    const handleOffcanvasHidden = async () => {
      console.log("Offcanvas close event triggered!");
      const signed = localStorage.getItem("signingCompleted");

      if (signed === "true") {
        setIsFinished(true);
        localStorage.removeItem("signingCompleted");

        if (props.refreshEnvelopeData) {
          try {
            await props.refreshEnvelopeData();
            // toast.success("Document data updated!");
          } catch (err) {
            // toast.error("Failed to update data");
          }
        }
      } else {
        setGetStarted(false);
        setAgreeTerms(false);
        setSignFillRequest(false);
        setSignatureDocumentData(null);
        setSummaries(null);
        setShowSummaryModal(false);
        setShowDecline(false);
        setDeclineReason("");

        document.body.classList.remove("offcanvas-backdrop", "overflow-hidden");
        document.body.style.overflow = "auto";
      }
    };

    offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasHidden);
    return () => {
      offcanvasEl.removeEventListener("hidden.bs.offcanvas", handleOffcanvasHidden);
    };
  }, [props]);

  useEffect(() => {
    if (props.envelopeData?.id > 0) {
      setSignDocumentList(props.envelopeData.sign_documents);
      setSummaries(props.envelopeData.sign_documents?.summaries);
    }
  }, [props.envelopeData]);

  const handleAgreeTerms = () => setAgreeTerms(!agreeTerms);

  const handleDecline = () => {
    setShowDecline(true);
    setDeclineReason("");
  };

  const cancelDecline = () => setShowDecline(false);

  const saveDecline = async () => {
    if (!declineReason.trim()) {
      toast.error("Please enter a reason for declining.");
      return;
    }

    try {
      props.setLoading(true);

      const formObj = props.envelopeData;
      const signDocId = props.envelopeData?.sign_documents?.[0]?.id;
      const current_recipient_id = props.envelopeData?.recipient_detail?.id;
      const declineTextareaValue = declineReason.trim();

      const obj = {
        envelope_data: formObj,
        signature_document_id: signDocId,
        recipient_id: current_recipient_id,
        decline_reason: declineTextareaValue,
      };

      console.log("Sending Decline Payload =>", obj);

      const res = await declineCustomerSignDocument(obj);

      if (res?.status === 200) {
        toast.success(res.data?.message || "Document declined successfully!");
        setShowDecline(false);

        if (props.refreshEnvelopeData) {
          await props.refreshEnvelopeData();
        }
      } else {
        toast.error(res.data?.message || "Something went wrong while declining.");
      }
    } catch (err) {
      console.error("Decline API error:", err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Oops... something went wrong while declining.";
      toast.error(msg);
    } finally {
      props.setLoading(false);
    }
  };

  const onRequestSignDocumentRender = async (e, data) => {
    if (data.is_edit === true) {
      e?.preventDefault?.();
      localStorage.removeItem("pagesPosition");
      localStorage.removeItem("placeholders");
      localStorage.removeItem("localSign");
      localStorage.removeItem("localInitial");
      props.setLoading(true);
      await setSignatureDocumentData(data);
      await setSignFillRequest(true);
      btnSignDocumentPopup.current?.click();
    }
  };

  const handleGetStarted = () => {
    if (!agreeTerms)
      return toast.error("Please agree to the Terms and Conditions first.");
    const editableDoc = signDocumentList.find((doc) => doc.is_edit === true);
    if (editableDoc) {
      onRequestSignDocumentRender(null, editableDoc);
      setGetStarted(true);
    } else {
      toast.success("Your document signing is already completed.");
    }
  };

  const handleShowSummary = () => {
    if (
      props.envelopeData?.sign_documents &&
      props.envelopeData.sign_documents.length > 0 &&
      props.envelopeData.sign_documents[0].summaries
    ) {
      setSummaries(props.envelopeData.sign_documents[0].summaries);
      setShowSummaryModal(true);
    } else {
      toast.error("No summary data found in this document.");
    }
  };

  useEffect(() => {
    const signed = localStorage.getItem("signingCompleted");
    if (signed === "true") setIsFinished(true);
  }, []);

  return (
    <div
      className="active fade show tab-pane"
      id="document-form-detail"
      role="tabpanel"
      aria-labelledby="document-form"
    >
      {isFinished ? (
        <div className="customer-finish-message">
          <div className="finish-box">
            <h2 className="finish-title">🎉 Contract Signed Successfully!</h2>
            <p className="finish-subtitle">
              Thank you for completing your signing process.
            </p>
            <p className="finish-subtitle">Please click below to finish your .</p>
          </div>
        </div>
      ) : !getStarted ? (
        <div className="customer-doc-wrapper p-4">
          <div className="customer-doc-container">
            {/* Header */}
            <div className="customer-doc-header">
              <h2 className="customer-doc-title ">Contract Signing Request</h2>
              <p className="customer-doc-subtitle">
                Please review the terms and conditions before proceeding
              </p>
            </div>

            {/* Terms Section */}
            <div className="customer-terms-content">
              <TermsConditions isUpdateMeta={false} />
            </div>

            {/* Summary Button */}
            <div className="customer-summary-wrapper">
              <button
                className="customer-btn-summary"
                onClick={handleShowSummary}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                View Contract Summary
              </button>
            </div>

            {/* Agreement Checkbox */}
            <div className="customer-agreement-box">
              <label className="customer-checkbox-wrapper">
                <input
                  type="checkbox"
                  id="agreeTerms"
                  checked={agreeTerms}
                  onChange={handleAgreeTerms}
                  className="customer-checkbox-input"
                />
                <span className="customer-checkbox-mark"></span>
                <span className="customer-checkbox-text">
                  I have read and agree to the{" "}
                  <strong>DocuSafe.ai Terms of Service</strong>
                </span>
              </label>
            </div>

            {/* Action Buttons */}
            <div className="customer-action-btns">
              <button
                onClick={handleDecline}
                className="customer-btn customer-btn-decline"
              >
                Decline to Sign
              </button>
              <button
                onClick={handleGetStarted}
                className={`customer-btn customer-btn-primary ${!agreeTerms ? "customer-btn-disabled" : ""
                  }`}
                disabled={!agreeTerms}
              >
                Get Started
              </button>
            </div>
          </div>

          {/* ✅ Decline Modal using ModalComponent */}
          <ModalComponent
            show={showDecline}
            handleClose={cancelDecline}
            title="Decline to Sign"
            footerButtons={[
              {
                label: "Cancel",
                variant: "secondary",
                onClick: cancelDecline,
              },
              {
                label: "Confirm Decline",
                variant: "danger",
                onClick: saveDecline,
              },
            ]}
          >
            <div className="p-3">
              <p className="modal-decline-desc mb-2 fw-bolder fs-6">
                This action will notify the sender and clear your progress.
              </p>
              <label className="form-label mb-2 text-dark">
                Reason for declining <span className="text-danger">*</span>
              </label>
              <textarea
                rows="5"
                className="form-control text-dark rounded"
                value={declineReason}
                onChange={(e) => setDeclineReason(e.target.value)}
                placeholder="Please provide a reason..."
              />
            </div>

          </ModalComponent>

          {/* ✅ Summary Modal using ModalComponent */}
          <ModalComponent
            show={showSummaryModal}
            handleClose={() => setShowSummaryModal(false)}
            title="Document Summary"
            size="lg"
            footerButtons={[
              {
                label: "Close",
                variant: "secondary",
                onClick: () => setShowSummaryModal(false),
              },
            ]}
          >
            <CustomerSummary
              show={showSummaryModal}
              onClose={() => setShowSummaryModal(false)}
              summaries={summaries}
              setSummaries={setSummaries}
              loading={props.loading}
              title="Contract Summary Overview"
            />
          </ModalComponent>
        </div>
      ) : null}

      <span
        className="d-none"
        ref={btnSignDocumentPopup}
        data-bs-toggle="offcanvas"
        data-bs-target="#signFillableForm"
      ></span>

      <SignFillablePopup
        formObj={props.envelopeData}
        setSignDocumentList={setSignDocumentList}
        signatureDocumentData={signatureDocumentData}
        setLoading={props.setLoading}
        signFillRequest={signFillRequest}
        handleSignFillableRequest={setSignFillRequest}
        summaries={summaries}
        setSummaries={setSummaries}
        onClose={() => setGetStarted(false)}
      />
    </div>
  );
}

export default DocumentsAndForm;
